import React, {RefObject} from 'react';

import {ViewerPanelId} from '../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {CommentUnfurlTypesEnum} from '../../../../../models/api/commentUnfurlModel';
import {
  ConversationBaseModel,
  ConversationModel,
  RConversation,
} from '../../../../../models/api/conversationModel';
import {PublicId} from '../../../../../models/applications/publicIdTypes';
import {ConversationPreviewContainer} from '../../../../common/conversations/conversationPreviewContainer';

/*
 * Helpers.
 */

export function buildLinkedConversationUnfurl(
  linkedConversation: ConversationModel,
  linkedConversationPublicId: PublicId<'conversation'>,
  accessLink?: string,
) {
  return [
    {
      token: linkedConversationPublicId,
      type: CommentUnfurlTypesEnum.LINKED,
      conversationId: linkedConversation.id,
      accessLink,
    },
  ];
}

export function maybeRenderConversationPreview(
  panelId: ViewerPanelId,
  shouldShowPreview: boolean,
  itemRef: RefObject<HTMLDivElement>,
  conversation: ConversationBaseModel,
) {
  if (!RConversation.is(conversation) || !shouldShowPreview || !itemRef.current) {
    return null;
  }

  return (
    <ConversationPreviewContainer
      panelId={panelId}
      conversation={conversation}
      anchor={itemRef}
      viewerConversationId={undefined}
    />
  );
}
